export const eventCategories = [
  { name: "Forums", icon: "ri-forbid-line" },
  { name: "Conferences", icon: "ri-mic-line" },
  { name: "Seminars", icon: "ri-presentation-line" },
  { name: "Competitions", icon: "ri-trophy-line" },
  { name: "Exhibitions", icon: "ri-gallery-line" },
  { name: "Factory Visits", icon: "ri-building-2-line" },
  { name: "International Delegations", icon: "ri-plane-line" },
];